import { useAccount, useMsal } from '@azure/msal-react';
import { getConfig } from '../config';
import { microsoftGraph } from '../constants';

const useAuthGetters = () => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const getGraphApiAuth = () => {
    if (account === null) {
      throw new Error('account is null when calling useAuthGetters.getGraphApiAuth');
    }

    return instance.acquireTokenSilent({
      scopes: [microsoftGraph.defaultScope],
      account: account,
    });
  };

  const getApiAuth = () => {
    if (account === null) {
      throw new Error('account is null when calling useAuthGetters.getApiAuth');
    }

    return instance.acquireTokenSilent({
      scopes: [getConfig().auth.apiReadScope],
      account: account,
    });
  };

  return { getGraphApiAuth, getApiAuth, account };
};

export default useAuthGetters;
